import React, { useState } from "react";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import { fadeIn, staggerContainer } from "../utils/motion";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

const API_BASE = (
  process.env.REACT_APP_ATAFRICA_API_URL || "http://localhost:2000"
).replace(/\/$/, "");

function splitName(fullName) {
  const parts = String(fullName || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return { first_name: "", last_name: "" };
  if (parts.length === 1) return { first_name: parts[0], last_name: "" };
  return {
    first_name: parts[0],
    last_name: parts.slice(1).join(" "),
  };
}

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    setSubmitting(true);

    const { first_name, last_name } = splitName(name);

    try {
      const response = await fetch(`${API_BASE}/api/discussion/add`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          first_name,
          last_name,
          email: email.trim(),
          phone: "",
          message: message.trim(),
          source: "qpafrica",
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setError(data.msg || data.message || "Failed to send message.");
        return;
      }
      setSuccess("Thank you — your message has been sent. We’ll get back to you soon.");
      setEmail("");
      setName("");
      setMessage("");
    } catch {
      setError("Failed to send message. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>Contact - QPAfrica</title>
        <meta name="description" content="Meta Description here" />
      </Helmet>
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: "false", amount: 0.1 }}
        className="relative flex min-h-screen w-full max-w-full flex-col bg-black text-white"
      >
        <NavBar />
        <div className="flex flex-1 flex-col justify-center px-4 pb-10 pt-28 sm:pt-32">
          <motion.div
            variants={fadeIn("down", "spring", 0.2, 0.75)}
            className="mx-auto w-full max-w-screen-md"
          >
            <h1 className="py-4 text-center text-2xl font-bold text-white sm:py-0 sm:text-3xl">
              Let’s talk. Get in touch with us
            </h1>
            <form
              onSubmit={handleSubmit}
              className="mx-auto my-6 w-full max-w-[350px] md:my-10"
            >
              <div className="mb-5">
                <label
                  htmlFor="name"
                  className="mb-2 block font-bold text-white"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="from_name"
                  name="from_name"
                  placeholder="Your name"
                  className="w-full rounded-lg bg-gray-700 p-3 text-gray-300 backdrop-blur-2xl focus:outline-none"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  required
                />
              </div>
              <div className="mb-5">
                <label
                  htmlFor="email"
                  className="mb-2 block font-bold text-white"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email_from"
                  name="email_from"
                  placeholder="example@email.com"
                  className="w-full rounded-lg bg-gray-700 p-3 text-gray-300 backdrop-blur-2xl focus:outline-none"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </div>
              <div className="mb-5">
                <label
                  htmlFor="message"
                  className="mb-2 block font-bold text-white"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Type here..."
                  rows={4}
                  className="w-full rounded-lg bg-gray-700 p-3 text-gray-300 backdrop-blur-2xl focus:outline-none"
                  value={message}
                  onChange={(event) => setMessage(event.target.value)}
                  required
                ></textarea>
              </div>
              {error ? (
                <p
                  role="alert"
                  className="mb-4 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2.5 text-sm text-red-300"
                >
                  {error}
                </p>
              ) : null}
              {success ? (
                <p
                  role="status"
                  className="mb-4 rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-2.5 text-sm text-emerald-300"
                >
                  {success}
                </p>
              ) : null}
              <button
                type="submit"
                disabled={submitting}
                className="w-full rounded-lg bg-blue-700 px-4 py-3 text-sm font-bold text-white hover:bg-blue-800 disabled:opacity-60"
              >
                {submitting ? "Sending..." : "Send"}
              </button>
            </form>
          </motion.div>
        </div>
        <Footer />
      </motion.div>
    </>
  );
};

export default Contact;
